export const conformInvitationFeatureKey = 'confirmInvitation';
